import { r as getStaticFooter, t as getStaticHeader } from "./header-CxiOPpL_.mjs";
//#region src/namespaces/gatsby-client.ts
const GatsbyClient = {
	getHeader: getStaticHeader,
	getFooter: getStaticFooter
};
//#endregion
export { GatsbyClient };
